import { render, staticRenderFns } from "./ComplianceWarning.vue?vue&type=template&id=29330efb&scoped=true&"
var script = {}
import style0 from "./ComplianceWarning.vue?vue&type=style&index=0&id=29330efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29330efb",
  null
  
)

export default component.exports